import {
  BaseCssVarValue,
  GetCssVarByClass
} from '@/views/game/components/gameCardSuit/components/baseCssVarInject'

export abstract class _LabelGameStatusBase extends BaseCssVarValue {
  abstract cssType: 'default'
  /** 状态标签的高度 */
  ['--label-game-status-height']?: string;
  /** 状态标签的内边距 */
  ['--label-game-status-padding']?: string;
  /** 状态标签的内边距 */
  ['--label-game-status-z-index']?: string;
  /** 状态标签的字号 */
  ['--status-text-font-size']?: string
}

/** 变量标签 */
export type _LabelGameStatusCssVar = GetCssVarByClass<_LabelGameStatusBase>
